import palette from '../palette';

export default {
	line: {
		borderColor: palette.primary.main,
	},
};
